import http from '@/services/http';
import logger from '@/services/logger';



const applePay = {
  customMerchantValidator: null,
  paymentGateway: null,
  requestPaymentPromise: {},
  session: null,

  createSession(options) {
    const config = applePay.paymentGateway.methods.applePay.applePayConfig;
    const version = options.version || 2;
    let { request } = options;

    if (!request) {
      const total = {
        ...config.total,
        amount: options.total.toString(),
        type: 'final'
      };

      request = {
        ...config,
        total
      };
    }

    applePay.session = new window.ApplePaySession(version, request);
  },

  isSupported() {
    try {
      if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
        return true;
      }

      return false;
    }

    catch (error) {
      logger.error(error);

      return false;
    }
  },

  onCancel() {
    const error = new Error('payment cancelled');
    error.statusCode = 'CANCELED';

    applePay.requestPaymentPromise.reject(error);
  },

  onPaymentAuthorized(event) {
    applePay.session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
    applePay.requestPaymentPromise.resolve(event);
  },

  async onValidateMerchant(event) {
    try {
      let validation;

      if (applePay.customMerchantValidator) {
        const response = await applePay.customMerchantValidator({
          event
        });

        validation = response.data;
      }

      else {
        const response = await http.post('/cardfree-api/v1/pat/merchant/validateApplePayMerchant', {
          domainName: window.location.hostname,
          storeId: applePay.paymentGateway.storeId,
          validationUrl: event.validationURL
        });

        validation = response.data;
      }

      applePay.session.completeMerchantValidation(validation);
    }

    catch (error) {
      applePay.session.abort();
      applePay.requestPaymentPromise.reject(error);
    }
  },

  requestPayment(options) {
    return new Promise((resolve, reject) => {
      applePay.customMerchantValidator = options.merchantValidator || null;
      applePay.paymentGateway = options.paymentGateway;
      applePay.requestPaymentPromise.resolve = resolve;
      applePay.requestPaymentPromise.reject = reject;

      applePay.createSession(options);

      applePay.session.oncancel = applePay.onCancel;
      applePay.session.onpaymentauthorized = applePay.onPaymentAuthorized;
      applePay.session.onvalidatemerchant = applePay.onValidateMerchant;

      applePay.session.begin();
    });
  }
};



export default applePay;
